import type { IconData } from '@stacksjs/iconify-core'

export const devicesTv: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15.84.65H.16v11.76h4.9v2.94h5.88v-2.94h4.9z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default devicesTv
